import { DOCS_URL } from "../../../config/constants.js";
import AuthorBio from "./AuthorBio.svelte";

export default {
    component: AuthorBio,
    name: "AuthorBio",
    description: "Displays author information with image, name, role, bio, and LinkedIn link",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/user-circle.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F77f073c306e8438ebd71507b7b87893f",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-authorbio--docs`,
    inputs: [
        {
            friendlyName: "Author",
            name: "author",
            type: "object",
            required: true,
            subFields: [
                {
                    friendlyName: "Name",
                    name: "name",
                    type: "text",
                    required: true,
                },
                {
                    friendlyName: "Role",
                    name: "role",
                    type: "text",
                },
                {
                    friendlyName: "Bio Image",
                    name: "bioImage",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "webp"],
                    helperText: "Square aspect ratio recommended (e.g., 400x400px)",
                    required: true,
                },
                {
                    friendlyName: "Short Bio",
                    name: "shortBio",
                    type: "longText",
                    helperText: "Author biography text",
                    required: true,
                },
                {
                    friendlyName: "LinkedIn Profile",
                    name: "linkedIn",
                    type: "url",
                    helperText: "LinkedIn profile URL (e.g., https://www.linkedin.com/in/username)",
                },
            ],
        },
    ],
};
